import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function GeneratorIcon(props) {
	return (
		<IconBase type="generator" {...props}>
			<path d="M15.6303 6.99998H17.2929C17.4255 6.99998 17.5527 6.94731 17.6464 6.85354L18.8787 5.62129C18.9573 5.54267 19.0599 5.4925 19.1702 5.47871L20.562 5.30473C20.8122 5.27345 21 5.06075 21 4.80859V4.10245C21 3.78938 20.7156 3.55332 20.4079 3.61101L17.1649 4.21906C17.0579 4.23913 16.9604 4.29358 16.8871 4.37416L15.2603 6.16365C14.9683 6.48483 15.1962 6.99998 15.6303 6.99998Z" />
			<path d="M11.7916 15.7064V13.1974H10.3968L12.4008 9.29356V11.8026H13.7435L11.7916 15.7064Z" />
			<path d="M2.5 7.99998C2.5 7.72384 2.72386 7.49998 3 7.49998H21C21.2761 7.49998 21.5 7.72384 21.5 7.99998V17C21.5 17.2761 21.2761 17.5 21 17.5H3C2.72386 17.5 2.5 17.2761 2.5 17V7.99998ZM12 8.49998C9.79158 8.49998 8 10.2916 8 12.5C8 14.7084 9.79158 16.5 12 16.5C14.2084 16.5 16 14.7084 16 12.5C16 10.2916 14.2084 8.49998 12 8.49998ZM7 8.99998H3.5V9.49998H7V8.99998ZM3.5 9.99998V10.5H7V9.99998H3.5ZM7 11H3.5V11.5H7V11Z" />
			<path d="M21 18V19H3V18H21Z" />
		</IconBase>
	);
}
GeneratorIcon.propTypes = iconPropTypes;
